import React, { useEffect, useRef, useState } from "react";

import Navbar from "../components/Navbar";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useBooking } from "../hooks/useBooking";
import { Booking } from "../declarations/booking";
import { CiSearch } from "react-icons/ci";
import Loader from "../components/common/Loader";
import { BookingDetailsModal } from "../components/Modal/BookingDetailModal";
import { usePackage } from "../hooks/usePackage";
import BookingCard from "../components/bookings/Booking";

// todo: all filters not working and the date next to next is not working

const Bookings = () => {
  const [isOpened, setIsOpened] = useState(true);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [bookingData, setBookingData] = useState<Booking[]>([]);
  const [FilteredBookingData, setFilteredBookingData] = useState<Booking[]>([]);
  const { getBookingData, declineBooking, getBookingFiltered } = useBooking();
  const { getPackageData } = usePackage();
  const [menuVisible, setMenuVisible] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState<Booking[]>([]);
  const [packageData, setPackageData] = useState<any>([]);
  const [selectedPackages, setSelectedPackages] = useState<string[]>([]);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [packageShowDropDown, setPackageShowDropDown] = useState(false);
  const packagedropdownRef: any = useRef(null);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [bookingToDecline, setBookingToDecline] = useState<
    string | null | undefined
  >(null);
  const [IsDeclineModalOpen, SetIsDeclineModalOpen] = useState<boolean>(false);
  const [referenceCode, setReferenceCode] = useState("");
  const [isFilterTriggered, setIsFilterTriggered] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuIndex, setMenuIndex] = useState<number | null>(null);

  const limit = 10;

  const toggleDropdown = (index: any) => {
    setDropdownOpen(dropdownOpen === index ? null : index);
  };

  const toggleMenu = (index: any) => {
    // Toggle menu visibility for the clicked index
    setMenuVisible((prev) => (prev === index ? null : index));
  };

  const handleClose = () => {
    setIsOpened(false);
  };

  const getBookingResponse = async (page: number) => {
    try {
      setLoading(true);
      const response = await getBookingData(page, limit);
      setLoading(false);
      setBookingData(response.booking.length > 0 ? response.booking : []);
      setTotalPages(
        response.totalData || Math.ceil(response.totalData / limit)
      );
      // console.log('resp', response)
    } catch (error) {
      console.log("Error fetching bookings:", error);
    }
  };

  const getBookingFilteredResponse = async () => {
    if (
      !fromDate &&
      !toDate &&
      !referenceCode &&
      selectedPackages.length === 0
    ) {
      // If no filters are applied, fetch all data
      setIsFilterTriggered(true);
      return getBookingResponse(currentPage);
    }

    try {
      setLoading(true);
      const response = await getBookingFiltered(
        currentPage,
        limit,
        selectedPackages.join(","),
        referenceCode && referenceCode,
        fromDate && fromDate,
        toDate && toDate
      );

      setFilteredBookingData(response.booking || []);
      setTotalPages(Math.ceil((response.totalData || 1) / limit));
    } catch (error) {
      console.error("Error fetching filtered bookings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBookingFilteredResponse();
  }, [selectedPackages, referenceCode, fromDate, toDate, currentPage]);

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  useEffect(() => {
    getBookingResponse(currentPage);
  }, [currentPage]);

  const handleViewClick = (id: string | undefined) => {
    console.log("");
    const filteredBooking = bookingData.filter((item) => item._id === id);
    setSelectedBooking(filteredBooking);
    setIsModalOpen(true);
    setMenuVisible(null);
  };

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>,
    index: number
  ) => {
    setAnchorEl(event.currentTarget);
    setMenuIndex(index);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuIndex(null);
  };

  const handleViewClickMui = (id: string | undefined) => {
    handleViewClick(id);
    handleMenuClose();
  };

  const handleDeclineClickMui = (id: string | undefined) => {
    handleDeclineClick(id);
    handleMenuClose();
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const getPackageResponse = async () => {
      const results = await getPackageData();
      setPackageData(results || []);
    };
    getPackageResponse();
  }, []);

  const handlePackageCheckboxToggle = (id: string) => {
    setSelectedPackages((prev: string[] = []) => {
      const updatedPackages = prev.includes(id)
        ? prev.filter((pkgId) => pkgId !== id)
        : [...prev, id];

      return updatedPackages;
    });
  };

  const handleDeclineClick = (id: string | null | undefined) => {
    setBookingToDecline(id);
    SetIsDeclineModalOpen(true);
  };

  const confirmDecline = async () => {
    if (bookingToDecline) {
      console.log("decle", bookingToDecline);
      setLoading(true);
      const response = await declineBooking(bookingToDecline);
      setLoading(false);
      SetIsDeclineModalOpen(false);
      setBookingToDecline(null);
    }
  };

  const cancelDecline = () => {
    setDropdownOpen(null);
    SetIsDeclineModalOpen(false);
    setBookingToDecline(null);
  };

  const filteredBooking = bookingData?.filter((book: any) => {
    const matchesPackageFilter =
      selectedPackages.length === 0 ||
      book.packages?.some((pkg: any) => selectedPackages.includes(pkg._id));
    const matchesReference = referenceCode;
    return matchesPackageFilter || matchesReference;
  });

  console.log("Filtered Booking:", filteredBooking);

  const filteredBookingResponse =
    FilteredBookingData.length > 0 ? FilteredBookingData : bookingData;

  console.log("filteedbooking", FilteredBookingData);

  return (
    <div>
      <Navbar />

      {isModalOpen && (
        <BookingDetailsModal
          booking={selectedBooking}
          onClose={() => setIsModalOpen(false)}
        />
      )}

      {/* Page Container */}
      <div className="flex flex-col items-center min-h-screen">
        <div className="w-full max-w-7xl mx-auto max-lg:px-4">
          {/* Page Title */}
          <h1 className="text-2xl font-semibold mt-10 mb-6">Bookings</h1>

          {/* Information Alert */}
          {isOpened && (
            <div className="bg-blue-100 text-blue-900 p-4 rounded-lg mb-4">
              <div className="flex justify-between">
                <p className="mb-5 text-black">
                  Here you can see all your received bookings and accept 'on
                  demand' bookings.
                </p>
                <button
                  onClick={handleClose}
                  className="cursor-pointer text-gray-700"
                >
                  <CloseOutlinedIcon />
                </button>
              </div>
              <ul className="list-disc list-inside text-sm mt-2 space-y-2">
                <li>
                  <a href="#" className="text-blue-700">
                    How can I see the details of a booking?
                  </a>
                  <p className="text-black ml-3">
                    To see all details for a booking, click on the booking. This
                    will expand the details panel.
                  </p>
                </li>
                <li>
                  <a href="#" className="text-blue-700">
                    How do I filter bookings by product and date?
                  </a>
                  <p className="text-black ml-3">
                    To filter by product, select a product from the list. For
                    date filtering, use the 'From' and 'To' date fields below.
                  </p>
                </li>
              </ul>
            </div>
          )}

          {/* Filter Section & Table Content */}
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Filter Section */}
            <div className="w-full lg:w-1/3 bg-white p-6 shadow rounded-lg">
              <h2 className="text-lg font-medium mb-4">Filter Options</h2>

              {/* Filter by Product */}
              <div className="relative">
                <div
                  className="w-full border border-gray-300 rounded px-4 py-2 cursor-pointer bg-white mb-3"
                  onClick={() => setPackageShowDropDown(!packageShowDropDown)}
                >
                  All Products
                </div>

                {packageShowDropDown && (
                  <div
                    ref={packagedropdownRef}
                    className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-md z-10 max-h-48 overflow-y-auto"
                  >
                    {packageData.packages?.map((option: any, index: any) => (
                      <div
                        key={index}
                        className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                      >
                        <input
                          type="checkbox"
                          id={`option-${index}`}
                          value={option._id}
                          className="mr-2 cursor-pointer"
                          checked={selectedPackages.includes(option._id)}
                          onChange={() =>
                            handlePackageCheckboxToggle(option._id)
                          }
                        />
                        <label
                          htmlFor={`option-${index}`}
                          className="cursor-pointer"
                        >
                          {option.title}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Filter by Activity Start Date */}
              <div className="mb-4">
                <label className="block text-gray-700 mb-1">
                  Filter by Activity Start Date
                </label>
                <div className="relative mb-2">
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    className="w-full pl-10 p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div className="relative">
                  <CalendarMonthIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    className="w-full pl-10 p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              {/* Filter by Reference Code */}
              <div className="mb-6">
                <label className="block text-gray-700 mb-1">
                  Filter by Reference Code
                </label>
                <input
                  type="text"
                  placeholder="Reference code"
                  value={referenceCode}
                  onChange={(e) => setReferenceCode(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>

              {/* Download Button */}
              <button className="w-full bg-blue-900 text-white py-2 rounded-lg hover:bg-blue-700">
                Download Brochure
              </button>
            </div>

            {loading ? (
              <Loader loading={loading} />
            ) : (
              <div className="w-full flex-grow bg-gray-50 shadow rounded-lg p-6 ">
                {/* Search & Actions Section */}
                <div className="flex justify-between items-center mb-4 gap-4 flex-wrap">
                  <div className="relative flex items-center">
                    <input
                      type="text"
                      placeholder="Make a search"
                      className="border rounded-lg py-2 px-4 w-72 focus:outline-blue-500"
                    />
                    <button className="absolute right-3">
                      <CiSearch className="text-gray-500" />
                    </button>
                  </div>
                  <div className="flex items-center gap-2">
                    <button className="text-blue-600 font-semibold">
                      Export
                    </button>
                    <button className="border rounded-lg py-1 px-3">
                      Weekly
                    </button>
                    <span>1st Jul - 31st Jul</span>
                    <CalendarMonthIcon className="text-gray-500" />
                  </div>
                </div>

                {/* Card-Based Layout */}

                <div className="space-y-4 overflow-x-auto min-h-screen">
                  {filteredBooking.length === 0 ? (
                    <div className="flex justify-center items-center mt-6 text-gray-600">
                      <WarningAmberOutlinedIcon />
                      <span className="ml-2">No bookings yet.</span>
                    </div>
                  ) : (
                    filteredBooking.map((booking, index) => (
                      <BookingCard
                        index={index}
                        key={index}
                        booking={booking}
                        anchorEl={anchorEl}
                        menuIndex={menuIndex}
                        handleMenuClose={handleMenuClose}
                        handleMenuOpen={handleMenuOpen}
                        handleDeclineClickMui={handleDeclineClickMui}
                        handleViewClickMui={handleViewClickMui}
                      />
                    ))
                  )}
                </div>

                <div className="flex justify-between mt-4">
                  <button
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                    className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
                  >
                    Previous
                  </button>
                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                    className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>

                {IsDeclineModalOpen && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-md shadow-lg max-w-md w-full text-center">
                      {/* Title */}
                      <h2 className="text-xl font-medium text-gray-900 mb-2">
                        Are you sure you want to decline booking?
                      </h2>

                      {/* Subtitle */}
                      <p className="text-sm text-gray-500 mb-6">
                        This action will cancel customer’s booking and their
                        order refunded.
                      </p>

                      {/* Action Buttons */}
                      <div className="flex justify-center space-x-4">
                        <button
                          onClick={cancelDecline}
                          className="px-6 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100 w-full"
                        >
                          No
                        </button>
                        <button
                          onClick={confirmDecline}
                          className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 w-full"
                        >
                          {loading ? "Please Wait..." : "Yes"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* No Data Message */}
                {bookingData.length === 0 && (
                  <div className="flex justify-center items-center mt-6 text-gray-600">
                    <WarningAmberOutlinedIcon />
                    <span className="ml-2">
                      No bookings match your filter. Please adjust your filters.
                    </span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bookings;
